import {Component, inject, OnInit} from '@angular/core'
import {IMessage, MessageService} from '../../services/message.service'
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardTitle
} from '@angular/material/card'
import {ListItemComponent} from '../list-item/list-item.component'
import {MatProgressBar} from '@angular/material/progress-bar'
import {MatDialog} from '@angular/material/dialog'
import {NoMessagesComponent} from '../no-messages/no-messages.component'

@Component({
  selector: 'spb-home',
  standalone: true,
  templateUrl: './home.component.html',
  imports: [
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatCard,
    ListItemComponent,
    MatProgressBar
  ],
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  public messages: IMessage[] = []

  private readonly messageService = inject(MessageService)

  private readonly dialog = inject(MatDialog)

  public ngOnInit() {
    this.messageService.getMessages()
      .subscribe(messages => {
        this.messages = messages
        this.messages.sort((a, b) => b.timeStamp - a.timeStamp)
        if(messages.length === 0) {
          this.dialog.open(NoMessagesComponent)
        }
      })
  }
}
